import { useRef } from "react"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDTypography from "components/MDTypography"

const AttachmentSlot = ({ label, docType, file, onSelect, disabled }) => {
  const inputRef = useRef(null)

  const handleClick = () => {
    if (disabled) return
    inputRef.current?.click()
  }

  const handleChange = (e) => {
    const f = e.target.files?.[0]
    if (f && onSelect) onSelect({ docType, file: f })
    e.target.value = ""
  }

  return (
    <MDBox
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={1.5}
      bgColor="grey-100"
      borderRadius="lg"
      mb={1}
    >
      <MDBox>
        <MDTypography variant="button" fontWeight="medium">
          {label}
        </MDTypography>
        {file && (
          <MDTypography variant="caption" color="text" display="block">
            {file.name || file.fileName}
          </MDTypography>
        )}
      </MDBox>
      <MDButton
        size="small"
        variant="outlined"
        color="info"
        onClick={handleClick}
        disabled={disabled}
      >
        {file ? "Replace" : "Upload"}
      </MDButton>
      <input
        ref={inputRef}
        type="file"
        hidden
        onChange={handleChange}
        disabled={disabled}
      />
    </MDBox>
  )
}

export default AttachmentSlot
